import { RefObject } from 'react';
import QRCodeComponent from '../QRCodeComponent/QRCodeComponent';
import Timer, { TimerHandle } from '../Timer/Timer';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { styles } from '~/components/IITSign/styles.ts';
import { QRListItem } from '~/components/IITSign/constants.ts';

interface ICloudQRVerificationProps {
  url: string;
  isCloudKeyQRVerificationModalOpen: boolean;
  timerRef: RefObject<TimerHandle | null>;
  handleTimeUp?: () => void;
  isLoading?: boolean;
}

const CloudQRVerification = ({
  url,
  isCloudKeyQRVerificationModalOpen,
  timerRef,
  handleTimeUp,
}: ICloudQRVerificationProps) => {
  const onTimerTimeUp = (): void => {
    handleTimeUp?.();
  };

  return (
    <>
      {isCloudKeyQRVerificationModalOpen && (
        <Box>
          <Typography variant={'h4'} sx={styles.documentsSignHeader}>
            Підписати документи
          </Typography>
          <Box sx={{ alignItems: 'center', padding: '0 150px 20px' }}>
            <Box sx={styles.QRCodeContainer}>
              <QRCodeComponent url={url} />
            </Box>
            <Timer ref={timerRef} onTimeUp={onTimerTimeUp} initialTime={300} />
            <Box sx={styles.QRCodeContainer}>
              <List sx={{ ml: 3, listStyleType: 'decimal', alignItems: 'center' }}>
                {QRListItem.map((text, index) => (
                  <ListItem key={index} sx={styles.listItem}>
                    <ListItemText primary={text} sx={{ fontSize: '14px' }} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default CloudQRVerification;
